export default __webpack_public_path__ + "static/media/icon_waistline.963e368d.png";